module.exports = __webpack_public_path__ + "assets/img/02-l.3502e0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/02-l.jpg
// module id = 34B5
// module chunks = 0